import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import AreaChart from "../../../Components/Charts/AreaChart";
import { axInst } from "../../../Components/Login/Service";

const fetchDealerOperationalEffcienecy = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_zone_job_card",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const fetchDealerOperationalEffcienecySecond = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_service_zone_revenue",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function OperationalEffcienecy() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const payload = {
    ...data,
    Dealer_status: "SCV Operational Efficiency",
  };

  const {
    data: apiData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dealerOperationalEffcienecy", payload],
    queryFn: () => fetchDealerOperationalEffcienecy(payload),
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: apiData2,
    isFetching: isFetching2,
    isError: isError2,
  } = useQuery({
    queryKey: ["dealerOperationalEffcienecySecond", payload],
    queryFn: () => fetchDealerOperationalEffcienecySecond(payload),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching || isFetching2)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError || isError2) return <div>Error loading data</div>;

  const combinedData = { ...(apiData || {}), ...(apiData2 || {}) };

  // 🔥 Transform API response correctly
  const chartsData =
    Object.keys(combinedData).length > 0
      ? Object.entries(combinedData).map(([title, value]) => {
          // Find dynamic FY keys
          const fyKeys = Object.keys(value)
            .filter((key) => key.startsWith("FY"))
            .sort();

          const prevFY =
            fyKeys.length > 1
              ? fyKeys[0]
              : fyKeys.length === 1
                ? fyKeys[0]
                : null;
          const currFY = fyKeys.length > 1 ? fyKeys[1] : null;

          return {
            title,
            monthlyData: value.Month_wise_revenue || {},
            target: value.Target,
            previousYear: {
              label: prevFY,
              value: prevFY ? value[prevFY] : null,
            },
            ytdActual: currFY
              ? { label: currFY, value: value[currFY] }
              : value.YTD_Actual,
          };
        })
      : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {chartsData.map((chart, index) => {
        let endpoint = "collbax-service/collbax_sso_service_revenue";
        let modalPayload = {};

        const titleLower = chart?.title?.toLowerCase() || "";

        if (titleLower.includes("fshr")) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "FSHR" };
        } else if (titleLower.includes("veh") && titleLower.includes("bay")) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { Partner_Type: [], sso_status: "VEH_BAY" };
        } else if (
          titleLower.includes("revenue") &&
          titleLower.includes("vehicle")
        ) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "REV_PER_VECH" };
        }

        return (
          <AreaChart
            key={index}
            title={chart.title}
            data={chart.monthlyData}
            target={chart.target}
            previousYear={chart.previousYear}
            ytdActual={chart.ytdActual}
            modalEndpoint={endpoint}
            modalPayload={modalPayload}
          />
        );
      })}
    </div>
  );
}
